import { render, staticRenderFns } from "./childrenage.vue?vue&type=template&id=bd132bbe&"
import script from "./childrenage.vue?vue&type=script&lang=js&"
export * from "./childrenage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bd132bbe')) {
      api.createRecord('bd132bbe', component.options)
    } else {
      api.reload('bd132bbe', component.options)
    }
    module.hot.accept("./childrenage.vue?vue&type=template&id=bd132bbe&", function () {
      api.rerender('bd132bbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-21kKXk9p4rI8L/JS/comp/childrenage.vue"
export default component.exports